export const antibotKeys = {
  all: ['antibot'] as const,
  verifyHumanity: () => [...antibotKeys.all, 'verifyHumanity'] as const,
};
